// P&L columns hidden for Fineco presentation (2026-03-30).
// Remove this set to re-enable across all portfolio views.
export const HIDDEN_COLUMNS = new Set(['pl_fiscale_euro', 'pl_fiscale_perc']);

// Helper: filter parallel headers/widths arrays together, removing hidden columns
export function filterColumns(
  headers: string[],
  widths: number[],
): { headers: string[]; widths: number[] } {
  const filtered = headers.reduce(
    (acc, header, i) => {
      if (!HIDDEN_COLUMNS.has(header)) {
        acc.headers.push(header);
        acc.widths.push(widths[i]);
      }
      return acc;
    },
    { headers: [] as string[], widths: [] as number[] },
  );
  return filtered;
}

// Helper: filter column display label mappings, removing hidden columns
export function filterMappings<T extends Record<string, string>>(mappings: T): T {
  const result = { ...mappings };
  HIDDEN_COLUMNS.forEach((col) => delete (result as Record<string, string>)[col]);
  return result;
}
